var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrecise(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 39,
    viewBox: "0 0 26 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.739746V12.1473H0.0208745L0 12.1663L8.34961 19.7524L0 27.3574L0.0208745 27.3765H0V38.765H25.0488V27.3765H25.028L25.0488 27.3574L16.6992 19.7524L25.0488 12.1663L25.028 12.1473H25.0488V0.739746H0ZM20.874 28.3081V34.9625H4.17481V28.3081L12.5244 20.703L20.874 28.3081ZM12.5244 18.8018L4.17481 11.1967V4.54227H20.874V11.1967L12.5244 18.8018Z",
    fill: "#CDD8FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrecise);
export default __webpack_public_path__ + "static/media/precise.9b2f792ad1b118404cee23b62bb4fab7.svg";
export { ForwardRef as ReactComponent };